module.exports = __webpack_public_path__ + "static/media/thirdflooronly.eb44d1a2.png";